import { logger } from '@fiverr-private/obs';
import { isAxiosError } from '../isAxiosError';

const DEFAULT_ENRICHMENT = {
    package: '@fiverr-private/identification_core',
};

interface Payload {
    error?: unknown;
    message?: string;
    enrichment?: Record<string, unknown>;
}

export const logError = ({ error, message, enrichment }: Payload) => {
    const errorToLog = new Error(message ?? (error as Error)?.message);
    (errorToLog as Error & { cause?: unknown }).cause = error;

    let originalError: Record<string, unknown> | undefined;

    if (isAxiosError(error)) {
        originalError = {
            message: error.message,
            status: error.response?.status,
            url: error.config?.url,
            method: error.config?.method,
            code: error.code,
        };
    } else if (error instanceof Error) {
        originalError = {
            message: error.message,
        };
    }

    logger.error(errorToLog, { ...DEFAULT_ENRICHMENT, ...enrichment, originalError });
};
